/**
 * The client side and public pages: the business side menu (SideNav) hides
 * on these, and so does Bailey the desk pet (BaileyPet), who belongs to the
 * business side only. Kept in its own module so both can import it without
 * SideNav and the pet importing each other.
 */

// Public/auth/marketing-site path prefixes — SideNav is hidden on these.
export const PUBLIC_PATH_PREFIXES = [
    '/login', '/signup', '/forgot-password', '/reset/',
    '/find-my-bookings',   // plain email-verify page, kept for old links
    '/social-login', '/redirect',
    '/magic/',        // magic-link landing (signed-out by definition)
    '/forms/fill/',
    '/book/', '/salon/',
    '/pro/',          // a professional's own public booking link
    '/store/',        // online product order success (post-Stripe landing)
    '/gift-cards/',   // gift-card wallet claim + email preview
    '/hair-salons/', '/barbers/', '/beauty-salons/', '/nail-salons/', '/spas/',
    '/terms-and-conditions', '/privacy-policy', '/hairdresser-terms-and-conditions',
    '/terms', '/privacy', '/partner-terms', '/beu-pay-terms',   // short public policy URLs
    '/redirection/', '/get-software', '/payment', '/booking-payment-success',
    '/coming-soon', '/404',
    '/dashboard', '/myaccount', '/legal', '/booking-detail/',
    '/beu-admin-x7k9/',
    '/sales-x7k9',      // sales engine has its own shell, like admin
];

export const isPublicPath = (pathname) => {
    if (pathname === '/') return true;
    return PUBLIC_PATH_PREFIXES.some(p => pathname === p || pathname.startsWith(p));
};
